import { Box, Skeleton } from '@mui/material';
import { pxToRem, pxTovW } from '@geneo2-web/shared-ui';

export const ShimmerPersonalisedJourneyCard = () => (
  <Box
    sx={{
      width: '100%',
      minWidth: 0,
      borderRadius: { xs: pxToRem(12), md: pxTovW(12) },
      bgcolor: 'common.white',
      boxShadow: '0px 2px 12px rgba(0,0,0,0.12)',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        gap: '10px',
        p: { xs: pxToRem(10), md: pxTovW(10) },
        alignItems: 'stretch',
      }}
    >
      {/* Left image: square */}
      <Box
        sx={{
          width: '30%',
          aspectRatio: '1 / 1',
          flexShrink: 0,
          overflow: 'hidden',
          borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
        }}
      >
        <Skeleton
          variant="rectangular"
          sx={{
            width: '100%',
            height: '100%',
          }}
        />
      </Box>

      {/* Right content */}
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: pxToRem(6), md: pxTovW(6) },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 'auto',
          }}
        >
          <Skeleton
            variant="text"
            sx={{
              width: '45%',
              height: { xs: pxToRem(14), md: pxTovW(16) },
            }}
          />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Skeleton variant="circular" sx={{ width: 4, height: 4 }} />
            <Skeleton
              variant="text"
              sx={{
                width: { xs: pxToRem(60), md: pxTovW(70) },
                height: { xs: pxToRem(12), md: pxTovW(14) },
              }}
            />
          </Box>
        </Box>
        <Skeleton
          variant="text"
          sx={{
            width: '85%',
            height: { xs: pxToRem(16), md: pxTovW(18) },
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Skeleton
            variant="text"
            sx={{
              width: '35%',
              height: { xs: pxToRem(12), md: pxTovW(14) },
            }}
          />
          <Skeleton
            variant="text"
            sx={{
              width: '40%',
              height: { xs: pxToRem(12), md: pxTovW(14) },
            }}
          />
        </Box>
        <Box
          sx={{
            background: '#F6F5FF',
            borderRadius: { xs: pxToRem(12), md: pxTovW(12) },
            padding: '7px 9px',
            marginTop: 'auto',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mt: 0.5,
            }}
          >
            <Skeleton
              variant="text"
              sx={{
                width: '25%',
                height: { xs: pxToRem(12), md: pxTovW(14) },
              }}
            />
            <Skeleton
              variant="text"
              sx={{
                width: pxToRem(32),
                height: { xs: pxToRem(12), md: pxTovW(12) },
              }}
            />
          </Box>
          <Skeleton
            variant="rounded"
            sx={{
              width: '100%',
              height: { xs: pxToRem(8), md: pxTovW(8) },
              borderRadius: 50,
              mt: 0.5,
            }}
          />
        </Box>
      </Box>
    </Box>
  </Box>
);
